import axios from "axios";

export class LogClient {
    constructor() {
        if (!localStorage.getItem('user_front_id')) {
            const userFrontId = this.generateUserId();
            localStorage.setItem('user_front_id', userFrontId);
        }

        this.lastInputData = {}; // Объект для хранения предыдущих значений инпутов
    }

    init() {
        const inputs = document.querySelectorAll('[data-log-input]');

        inputs.forEach(input => {
            if (input.type === 'checkbox') {
                input.addEventListener('click', this.handleInputChange.bind(this));
            } else {
                input.addEventListener('change', this.handleInputChange.bind(this));
                input.addEventListener('blur', this.handleInputChange.bind(this));
            }
        })
    }

    handleInputChange(event) {
        const input = event.target;
        const inputName = input.name;
        const inputValue = input.value.trim();

        // Проверка, если значение инпута не изменилось или имя инпута совпадает с предыдущим, не отправляем лог
        if (inputValue === this.lastInputData[inputName] && inputName === this.lastInputName) {
            return;
        }

        const userFrontId = localStorage.getItem('user_front_id');
        const logEvent = 'user_input';
        const extraData1 = inputName;
        const extraData2 = inputValue;

        this.sendLog(userFrontId, logEvent, extraData1, extraData2);
        this.lastInputData[inputName] = inputValue;
        this.lastInputName = inputName;
    }

    // Отправка кастомного лога
    sendEvent(event, extraData1, extraData2) {
        const userFrontId = localStorage.getItem('user_front_id');

        // Преобразование объектов и исключений в строку
        if (typeof extraData1 === 'object' || extraData1 instanceof Error) {
            extraData1 = JSON.stringify(extraData1);
        }
        if (typeof extraData2 === 'object' || extraData2 instanceof Error) {
            extraData2 = JSON.stringify(extraData2);
        }

        //const instance = new LogClient()

        this.sendLog(userFrontId, event, extraData1, extraData2);
    }

    // Отправка лога на бэкенд
    sendLog(userFrontId, event, extraData1, extraData2) {
        const fd = new FormData()
        fd.append('user_front_id', userFrontId);
        fd.append('event', event);
        fd.append('extra_data_1', extraData1);
        fd.append('extra_data_2', extraData2);

        axios.post('/main/log', fd)
            .then(response => {
                if (response.data && response.data.user_front_id) {
                    localStorage.setItem('user_front_id', response.data.user_front_id);
                }
            })
            .catch(error => {});
    }

    generateUserId() {
        // Генерируем уникальный ID для пользователя
        const timestamp = Date.now().toString();
        const randomPart = Math.random().toString().slice(2, 8); // Генерируем случайную часть из 6 цифр

        return timestamp + randomPart;
    }
}